import { Button, Drawer, Space } from 'antd'
import { uniqueId } from 'lodash'
import { useEffect, useState } from 'react'

interface IPROS {
  uniqueValue: any
  identifier: any
  rowValues: any
  getTableRow: any
  statistics: any
}

const Values: React.FC<IPROS> = ({
  uniqueValue,
  identifier,
  rowValues,
  getTableRow,
  statistics
}) => {
  const [drawerVisible, setDrawerVisible] = useState(false)
  const [nullValues, setNullValues] = useState<any>(null)
  const [valueUnique, setValueUnique] = useState<any>(null)
  const [statsValue, setStatsValue] = useState<any>(null)

  const handleOpenDrawer = () => {
    setDrawerVisible((prev) => !prev)
  }

  const handleCloseDrawer = () => {
    setDrawerVisible(true)
  }

  useEffect(() => {
    if (rowValues && Object.keys(rowValues)?.includes(identifier)) {
      const nullValueForIdentify = rowValues[identifier]
      setNullValues(nullValueForIdentify)
    }
  }, [identifier, rowValues])

  useEffect(() => {
    if (uniqueValue && Object.keys(uniqueValue)?.includes(identifier)) {
      const uniqueValueForIdentify = uniqueValue[identifier]
      setValueUnique(uniqueValueForIdentify)
    }
  }, [identifier, uniqueValue])

  useEffect(() => {
    if (statistics && Object.keys(statistics)?.includes(identifier)) {
      const statsValueForIdentify = statistics[identifier]
      setStatsValue(statsValueForIdentify)
    }
  }, [identifier, statistics])

  return (
    <div onClick={handleOpenDrawer}>
      <p style={{ display: 'flex', gap: '5px', justifyContent: 'center', whiteSpace: 'nowrap' }}>
        <span>Unique Values :</span>

        {uniqueValue &&
          Object.keys(uniqueValue)?.map((t: any, index: any) => {
            if (t === identifier) {
              return <span key={uniqueId()}>{uniqueValue && uniqueValue[t]}</span>
            }
            return null
          })}
      </p>
      <p style={{ display: 'flex', gap: '5px', justifyContent: 'center', whiteSpace: 'nowrap' }}>
        <span>Average :</span>
        <span>{statsValue?.average}</span>
      </p>
      <p style={{ display: 'flex', gap: '5px', justifyContent: 'center', whiteSpace: 'nowrap' }}>
        <span>Max :</span>
        <span>{statsValue?.max}</span>
      </p>
      <p style={{ display: 'flex', gap: '5px', justifyContent: 'center', whiteSpace: 'nowrap' }}>
        <span>Min :</span>

        <span>{statsValue?.min}</span>
      </p>
      <Drawer
        title={identifier}
        width={500}
        // closable={true}
        onClose={handleCloseDrawer}
        open={drawerVisible}
        extra={
          <Space>
            <Button onClick={handleCloseDrawer}>X</Button>
          </Space>
        }
      >
        <div style={{ display: 'flex', width: '100%' }}>
          <p
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              border: '1px solid hsl(240, 17.4%, 91%)',
              margin: '0px',
              width: '33%',
              padding: '16px'
            }}
          >
            <span style={{ color: 'hsl(240, 10.3%, 38%)', fontSize: '12px' }}>Rows</span>
            <span style={{ fontSize: '20px', color: 'hsl(240, 46.3%, 8%)' }}>{getTableRow}</span>
          </p>
          <p
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              margin: '0px',
              width: '33%',
              border: '1px solid hsl(240, 17.4%, 91%)',
              padding: '16px'
            }}
          >
            <>
              <span style={{ color: 'hsl(240, 10.3%, 38%)', fontSize: '12px' }}>Empty Rows</span>
              <span style={{ fontSize: '20px', color: 'hsl(240, 46.3%, 8%)' }}>{nullValues}</span>
            </>
          </p>
          <p
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              margin: '0px',
              width: '33%',
              border: '1px solid hsl(240, 17.4%, 91%)',
              padding: '16px'
            }}
          >
            <span style={{ color: 'hsl(240, 10.3%, 38%)', fontSize: '12px' }}>Unique Values</span>
            <span style={{ fontSize: '20px', color: 'hsl(240, 46.3%, 8%)' }}>{valueUnique}</span>
          </p>
        </div>
        <div style={{ display: 'flex', width: '100%' }}>
          <p
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              border: '1px solid hsl(240, 17.4%, 91%)',
              margin: '0px',
              width: '33%',
              padding: '16px'
            }}
          >
            <span style={{ color: 'hsl(240, 10.3%, 38%)', fontSize: '12px' }}>Average</span>
            <span style={{ fontSize: '20px', color: 'hsl(240, 46.3%, 8%)' }}>
              {statsValue?.average}
            </span>
          </p>
          <p
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              margin: '0px',
              width: '33%',
              border: '1px solid hsl(240, 17.4%, 91%)',
              padding: '16px'
            }}
          >
            <>
              <span style={{ color: 'hsl(240, 10.3%, 38%)', fontSize: '12px' }}>Max</span>
              <span style={{ fontSize: '20px', color: 'hsl(240, 46.3%, 8%)' }}>
                {statsValue?.max}
              </span>
            </>
          </p>
          <p
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              margin: '0px',
              width: '33%',
              border: '1px solid hsl(240, 17.4%, 91%)',
              padding: '16px'
            }}
          >
            <span style={{ color: 'hsl(240, 10.3%, 38%)', fontSize: '12px' }}>Min</span>
            <span style={{ fontSize: '20px', color: 'hsl(240, 46.3%, 8%)' }}>
              {statsValue?.min}
            </span>
          </p>
        </div>
        <div
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '15%'
          }}
        >
          <p style={{ display: 'flex', gap: '20px', alignItems: 'center', fontSize: '20px' }}>
            <span>Unique Value</span>{' '}
            <span style={{ fontSize: '20px' }}>
              {uniqueValue &&
                Object.keys(uniqueValue)?.map((t: any) => {
                  if (t === identifier) {
                    return <span key={uniqueId()}>{uniqueValue && uniqueValue[t]}</span>
                  }
                  return null
                })}
            </span>
          </p>
        </div>
      </Drawer>
    </div>
  )
}

export default Values
